<template>
  <el-table
    v-if="showTable"
    v-loading="tableLoading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
    :ref="tableRef"
    :data="tableData"
    :header-cell-style="{background:'#eceff6',color:'#444444',border:'1px solid #dcdfe6'}"
    :cell-style="{border:'1px solid #dcdfe6'}"
    stripe
    style="border: 1px solid #dcdfe6;"
    :max-height="(screenHeight-100)>600?(screenHeight-100):'600'"
  >
    <el-table-column type="index" label="序号" :min-width="isPc?'40':'35'" align="center" fixed="left">
    </el-table-column>
    <template v-if="isPc">
      <el-table-column prop="province" :label="isPc?'所属区域':'区域'" :min-width="isPc?'60':'40'" align="center">
      </el-table-column>
      <el-table-column prop="city" :label="isPc?'城市':'市'" :min-width="isPc?'72':'35'" align="center">
      </el-table-column>
      <el-table-column prop="category" label="分类" :min-width="isPc?'72':'55'" align="center">
      </el-table-column>
      <el-table-column prop="associatedName" label="所属名称" :min-width="isPc?'72':'50'" align="center">
      </el-table-column>
    </template>
    <el-table-column prop="sourceName":label="'来源渠道\n(ID)'" :min-width="isPc?'100':'55'" align="center" :fixed="!isPc">
      <template slot-scope="scope">
        <div>
          {{ scope.row.sourceName }}{{ scope.row.sourceId?`(${scope.row.sourceId})`:'' }}
        </div>
      </template>
    </el-table-column>
    <el-table-column label="合计" align="center">
      <el-table-column prop="stageTotalAmount" :label="'总样本量'" :min-width="isPc?'60':'55'" align="center">
      </el-table-column>
    </el-table-column>
    <el-table-column align="center">
      <template slot="header">
        <div>第一阶段样本采集量</div>
        <div>(7.22-7.31)</div>
      </template>
      <el-table-column prop="firstStageTotalAmount" :label="'总样本量'" :min-width="isPc?'90':'62'" align="center">
      </el-table-column>
    </el-table-column>
    <el-table-column align="center">
      <template slot="header">
        <div>第二阶段样本采集量</div>
        <div>(8.1-8.15)</div>
      </template>
      <el-table-column prop="totalAmount" :label="'总样本量\n(X+Y)'" :min-width="isPc?'60':'55'" align="center">
      </el-table-column>
      <el-table-column label="主问卷采集量" align="center" :min-width="isPc?'60':'55'">
        <el-table-column prop="amount" :label="'小计(X)'" :min-width="isPc?'60':'55'" align="center">
        </el-table-column>
        <el-table-column prop="publicAmount" label="公众版" :min-width="isPc?'60':'55'" align="center">
        </el-table-column>
        <el-table-column prop="employmentAmount" label="从业版" :min-width="isPc?'60':'55'" align="center">
        </el-table-column>
      </el-table-column>
      <el-table-column prop="specialAmount" :label="'专题问卷采集量\n(Y)'" :min-width="isPc?'60':'55'" align="center">
      </el-table-column>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: 'InvitationTable',
  props: {
    type: {
      type: Number,
      default: 1
    },
    tableLoading: {
      type: Boolean,
      default: false
    },
    isPc: {
      type: Boolean,
      default: false
    },
    showTable: {
      type: Boolean,
      default: false
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: ''
    },
    tableRef: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    },
    screenHeight: {
      type: Number,
      default: document.body.screenHeight
    },
  },
  data() {
    return {
    }
  },
  created() {
  },
  updated() {
  },
  methods: {

  }
};
</script>

<style scoped>

@media screen and (max-width: 768px) {
}
</style>



// WEBPACK FOOTER //
// src/components/table/InvitationTable.vue